var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingListFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5h-1.586l-3.707-3.707a.999.999 0 00-1.414 0L13.5 3.086l-1.793-1.793a.999.999 0 00-1.414 0L6.586 5H5.542L4.991.868A1 1 0 004 0H1v2h2.125l1.884 14.132A1 1 0 006 17h14a.998.998 0 00.98-.804l2-10A.998.998 0 0022 5zm-6-1.586L17.586 5h-2.172l-.5-.5L16 3.414zm-5 0L12.586 5H9.414L11 3.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM22 21.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
  })));
}
export default SvgShoppingListFilled;